import React, { useState, useEffect, useRef } from "react";
import { apiCallGeneric } from "../../service/api-service.js";
import { ReactComponent as ArrowDownIcon } from "../../assets/svg/arrow-down.svg";
import { ReactComponent as ArrowUpIcon } from "../../assets/svg/arrow-up.svg";

const SearchWithFreeText = ({ onDropdownChange, onChangeSearch, apiUrl, placeholder, selectedValue, selectedOption, params = {}, searchLimit = 0, readOnly, numberOnly }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [options, setOptions] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dropdownRef = useRef(null);

  const fetchOptions = async () => {
    setLoading(true);
    setError(null);
    try {
      if (apiUrl !== undefined && apiUrl !== "") {
        const queryParams = { ...params, term: searchTerm ?? "" };
        const queryString = new URLSearchParams(queryParams).toString();
        const fullUrl = `${apiUrl}${apiUrl.includes("?") ? "&" : "?"}${queryString}`;
        
        const response = await apiCallGeneric("get", fullUrl);
        if (response.status === 200 && response.data.success === true) {
          setOptions(response.data.suggestionlist);
          setFilteredOptions(response.data.suggestionlist);
        } else {
          setOptions([]);
          setFilteredOptions([]);
        }
      }
    } catch (err) {
      console.error("Error fetching options:", err);
      setError("Failed to fetch options. Try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setSearchTerm(selectedValue);
  }, [selectedValue]);

  useEffect(() => {
    if (searchLimit <= (searchTerm?.length || 0) || searchLimit === 0) {
      fetchOptions();
    }
  }, [searchTerm]);

  useEffect(() => {
    if (!searchTerm || typeof searchTerm !== "string") {
      setFilteredOptions(options);
    } else {
      setFilteredOptions(options.filter((option) => option.label && option.label.toLowerCase().includes(searchTerm.toLowerCase())));
    }
  }, [searchTerm, options]);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
    if (!isOpen) fetchOptions();
  };

  const selectOption = (option) => {
    onDropdownChange(option);
    setIsOpen(false);
  };

  return (
    <div ref={dropdownRef} style={{ position: "relative", height: "40px" }}>
      <div onClick={toggleDropdown} style={{ height: "40px", padding: "10px", border: isOpen ? "1.4px solid #2C8C53" : "1px solid #E5E5E5", borderRadius: "8px", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", background: "#FFFFFF", color: selectedOption || selectedValue !== "" ? "#1E1E1E" : "#81878C" }}>
        <input
          type="text"
          value={typeof searchTerm === "string" ? searchTerm : searchTerm?.label || ""}
          onChange={(e) => {
            const value = numberOnly ? e.target.value.replace(/\D/g, "") : e.target.value;
            setSearchTerm(value);
            if (typeof onChangeSearch === "function") {
              onChangeSearch(value);
            }
          }}
          placeholder={placeholder || "Search..."}
          readOnly={readOnly ?? false}
          style={{ width: "100%", border: "none", outline: "none", borderBottom: "1px solid #fff", boxSizing: "border-box", color: "#1E1E1E", background: "transparent", fontWeight: "300", fontSize: "14px", color: "#172b4d" }}
        />

        <span style={{ marginLeft: "10px" }}>{isOpen ? <ArrowUpIcon /> : <ArrowDownIcon />}</span>
      </div>

      {isOpen && !readOnly && (
        <div style={{ position: "absolute", top: "100%", left: 0, right: 0, border: "1px solid #ccc", borderRadius: "4px", background: "#fff", zIndex: 1000, maxHeight: "200px", overflowY: "auto" }}>
          {loading ? (
            <div style={{ padding: "10px", textAlign: "center" }}>Loading...</div>
          ) : error ? (
            <div style={{ padding: "10px", textAlign: "center", color: "red" }}>{error}</div>
          ) : filteredOptions.length > 0 ? (
            filteredOptions.map((option, index) => (
              <div
                key={index}
                onClick={() => selectOption(option)}
                style={{
                  padding: "10px",
                  cursor: "pointer",
                  background: selectedOption && selectedOption.id === option.id ? "#f0f0f0" : "#fff",
                  color: "#172b4d",
                  textAlign: "left",
                  fontSize: "14px",
                  fontWeight: "400",
                }}>
                {option.label}
              </div>
            ))
          ) : (
            <div style={{ padding: "10px", textAlign: "center" }}>No options found.</div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchWithFreeText;
